import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Component } from 'react';
import PromotionAction, { PromoActionKey } from '../../utils/PromotionAction';
import CdnPath from '../../utils/cdnPath';
import Logger from '../../lib/analytics/logger';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import { sendWelcomeNewsEvent } from './analytics/welcomeNewsLogger';
import { WELCOME_NEWS_EVENT_TYPES } from './constants';
import NotificationContext from '../../context/NotificationContext';

var News = /*#__PURE__*/function (_Component) {
  _inherits(News, _Component);

  var _super = _createSuper(News);

  function News() {
    var _this;

    _classCallCheck(this, News);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.clickHandler = function () {
      var _this$props = _this.props,
          newsData = _this$props.newsData,
          navigation = _this$props.navigation,
          coin = _this$props.coin;

      var _ref = newsData || {},
          action = _ref.action,
          game = _ref.game,
          externalUrl = _ref.externalUrl,
          campaign_id = _ref.campaign_id;

      var handler = PromotionAction.getActionCallback(navigation, {
        type: action,
        game: game,
        externalUrl: externalUrl,
        campaign_id: campaign_id
      }, _this.context);
      sendWelcomeNewsEvent(WELCOME_NEWS_EVENT_TYPES.PRESS_WELCOME_NEWS, {
        action: action,
        game: game,
        externalUrl: externalUrl,
        campaign_id: campaign_id
      });
      handler();

      if (action === PromoActionKey.GO_TO_COIN_STORE) {
        Logger.setActionTrigger('welcomeNews');
        var trigger = Logger.getActionTrigger();
        var eventPayload = {
          balance_before: coin.toString(),
          type: 'regular',
          trigger: trigger || ''
        };
        Logger.sendEvent(EVENT_TYPES.STORE_OPENED, eventPayload);
      }
    };

    _this.getImageUrl = function (image) {
      var ImagesCdnBaseUrl = _this.props.assetsUrls.ImagesCdnBaseUrl;
      if (!ImagesCdnBaseUrl) return null;
      return "".concat(ImagesCdnBaseUrl).concat(CdnPath.LOBBY_ADVERTS).concat(image);
    };

    return _this;
  }

  _createClass(News, [{
    key: "render",
    value: function render() {
      var _this$props$newsData = this.props.newsData,
          image = _this$props$newsData.image,
          action = _this$props$newsData.action;
      return this.props.render({
        image: this.getImageUrl(image),
        showButton: action !== PromoActionKey.NO_ACTION,
        clickHandler: this.clickHandler
      });
    }
  }]);

  return News;
}(Component);

News.contextType = NotificationContext;
export { News as default };